import { render, staticRenderFns } from "./UpdateAppointmentView.vue?vue&type=template&id=92092932"
import script from "./UpdateAppointmentView.vue?vue&type=script&lang=js"
export * from "./UpdateAppointmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports